import spinnerAnim from "./spinner.svg";
import downloadLoader from "./downloadLoader.svg";

export { spinnerAnim, downloadLoader };
